import { render, staticRenderFns } from "./Connects.vue?vue&type=template&id=a770f166&scoped=true&"
import script from "./Connects.vue?vue&type=script&lang=js&"
export * from "./Connects.vue?vue&type=script&lang=js&"
import style0 from "./Connects.vue?vue&type=style&index=0&id=a770f166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a770f166",
  null
  
)

export default component.exports